import { styled as l, css as n } from "styled-components";
import { breakpoints as c } from "./atoms-v2125.js";
function g(i) {
  return i.$isHighlightedOverflowCell ? n`
      background-color: ${({ theme: r }) => {
    var o;
    return (o = r == null ? void 0 : r.get) == null ? void 0 : o.call(r, `ui.calendar.${i.$colorTheme}.dayBkgActive`);
  }};
    ` : i.$isMinSelectionOverflowCell ? n`
      background-color: transparent;
      border-bottom: dashed 1px
        ${({ theme: r }) => {
    var o;
    return (o = r == null ? void 0 : r.get) == null ? void 0 : o.call(r, `ui.calendar.${i.$colorTheme}.informativeStroke`);
  }};
      ${({ theme: r }) => {
    var o;
    return i.$isRightSideBoundaryOfMinSelectionRange ? (o = r == null ? void 0 : r.get) == null ? void 0 : o.call(r, `ui.calendar.${i.$colorTheme}.informativeStroke`) : "none";
  }};
      border-top: dashed 1px
        ${({ theme: r }) => {
    var o;
    return (o = r == null ? void 0 : r.get) == null ? void 0 : o.call(r, `ui.calendar.${i.$colorTheme}.informativeStroke`);
  }};
    ` : i.$isDisabledForOverflow ? n`
      background-color: transparent;
    ` : i.$isStartDate || i.$isEndDate ? n`
      background-color: ${({ theme: r }) => {
    var o;
    return (o = r == null ? void 0 : r.get) == null ? void 0 : o.call(r, `ui.calendar.${i.$colorTheme}.arrDepBkgSelected`);
  }};
    ` : i.$isDisabledForAvailability && i.$isSelectedBridgeDate ? n`
      background-color: transparent;
      border-bottom: dashed 1px
        ${({ theme: r }) => {
    var o;
    return (o = r == null ? void 0 : r.get) == null ? void 0 : o.call(r, `ui.calendar.${i.$colorTheme}.informativeStroke`);
  }};
      border-top: dashed 1px
        ${({ theme: r }) => {
    var o;
    return (o = r == null ? void 0 : r.get) == null ? void 0 : o.call(r, `ui.calendar.${i.$colorTheme}.informativeStroke`);
  }};
    ` : !i.$isDisabledForAvailability && i.$isSelectedBridgeDate ? n`
      background-color: ${({ theme: r }) => {
    var o;
    return (o = r == null ? void 0 : r.get) == null ? void 0 : o.call(r, `ui.calendar.${i.$colorTheme}.dayBkgActive`);
  }};
    ` : !i.$isDisabledForAvailability && i.$isConsideredBridgeDate ? n`
      background-color: ${({ theme: r }) => {
    var o;
    return (o = r == null ? void 0 : r.get) == null ? void 0 : o.call(r, `ui.calendar.${i.$colorTheme}.dayBkgActive`);
  }};
    ` : i.$isDisabledForRange && !i.$isBridgeDateInclusive ? n`
      background-color: transparent;
      border-bottom: dashed 1px;
      ${({ theme: r }) => {
    var o;
    return (o = r == null ? void 0 : r.get) == null ? void 0 : o.call(r, `ui.calendar.${i.$colorTheme}.informativeStroke`);
  }};
      border-left: solid 1px ${i.$isRightSideBoundaryOfMinSelectionRange ? "transparent" : "none"};
      border-right: dashed 1px
        ${({ theme: r }) => {
    var o;
    return i.$isRightSideBoundaryOfMinSelectionRange ? (o = r == null ? void 0 : r.get) == null ? void 0 : o.call(r, `ui.calendar.${i.$colorTheme}.informativeStroke`) : "none";
  }};
      ${({ theme: r }) => {
    var o, a;
    return i.$isRightSideBoundaryOfMinSelectionRange ? `border-bottom-right-radius: ${(o = r == null ? void 0 : r.get) == null ? void 0 : o.call(r, "tokens.radius.calendarDayRadius")}px;
             border-top-right-radius: ${(a = r == null ? void 0 : r.get) == null ? void 0 : a.call(r, "tokens.radius.calendarDayRadius")}px;` : "";
  }}
      border-top: dashed 1px
        ${({ theme: r }) => {
    var o;
    return (o = r == null ? void 0 : r.get) == null ? void 0 : o.call(r, `ui.calendar.${i.$colorTheme}.informativeStroke`);
  }};
    ` : n`
    background-color: transparent;
  `;
}
function u(i, r) {
  return i.$isDisabledInclusive && !i.$isCheckoutDate && !i.$isSelectedBridgeDate ? n`
      color: ${({ theme: o }) => {
    var a;
    return (a = o == null ? void 0 : o.get) == null ? void 0 : a.call(o, `tokens.text.${i.$colorTheme}.disabled`);
  }};
    ` : i.$isStartDate || i.$isEndDate && !r ? n`
      color: ${({ theme: o }) => {
    var a;
    return (a = o == null ? void 0 : o.get) == null ? void 0 : a.call(o, `ui.calendar.${i.$colorTheme}.arrDepText`);
  }};
    ` : i.$isEndDate && r ? n`
      color: transparent;
    ` : i.$isPriceText && !i.$isSelectedBridgeDate ? n`
      color: ${({ theme: o }) => {
    var a;
    return (a = o == null ? void 0 : o.get) == null ? void 0 : a.call(o, `tokens.text.${i.$colorTheme}.secondary`);
  }};
    ` : n`
    color: ${({ theme: o }) => {
    var a;
    return (a = o == null ? void 0 : o.get) == null ? void 0 : a.call(o, `tokens.text.${i.$colorTheme}.primary`);
  }};
  `;
}
function x(i) {
  return i.$isDisabledInclusive && !i.$isCheckoutDate ? n`
      cursor: default;
    ` : n`
    cursor: pointer;
  `;
}
const f = l.div`
  --extension-width: 16px;

  align-items: center;
  border-bottom: solid 1px transparent;
  border-left: none;
  border-radius: 0;
  border-right: none;
  border-top: solid 1px transparent;
  box-sizing: content-box !important;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  -webkit-font-smoothing: ${({ $isEndDate: i, $isStartDate: r }) => i || r ? "antialiased" : "subpixel-antialiased"};
  gap: 1px;
  height: 34px;
  justify-content: ${({ $hasPriceContent: i }) => i ? "flex-start" : "center"};
  padding: 6px 3px 8px;
  position: relative;

  ${(i) => g(i)}
  ${(i) => x(i)}

  &:hover {
    ${({ $colorTheme: i, $isDisabledInclusive: r, $isEndDate: o, $isSelectedBridgeDate: a, $isStartDate: $, theme: d }) => {
  var s;
  if (!(r || $ || o || a))
    return `
        background-color: ${(s = d == null ? void 0 : d.get) == null ? void 0 : s.call(d, `ui.calendar.${i}.dayBkgHover`)};
      `;
}}
  }

  &:focus {
    ${({ $colorTheme: i, theme: r }) => {
  var o, a;
  return `
        border-radius: ${(o = r == null ? void 0 : r.get) == null ? void 0 : o.call(r, "tokens.radius.calendarDayRadius")}px;
        border: 1px solid ${(a = r == null ? void 0 : r.get) == null ? void 0 : a.call(r, `ui.calendar.${i}.dayFocus`)};
      `;
}}
  }

  ${({ $isStartDate: i, theme: r }) => {
  var o, a;
  return i && n`
      border-bottom-left-radius: ${(o = r == null ? void 0 : r.get) == null ? void 0 : o.call(r, "tokens.radius.calendarDayRadius")}px;
      border-top-left-radius: ${(a = r == null ? void 0 : r.get) == null ? void 0 : a.call(r, "tokens.radius.calendarDayRadius")}px;
    `;
}}

  ${({ $isDisabledForOverflow: i, $isEndDate: r, theme: o }) => {
  var a, $;
  return r && !i && n`
      border-bottom-right-radius: ${(a = o == null ? void 0 : o.get) == null ? void 0 : a.call(o, "tokens.radius.calendarDayRadius")}px;
      border-top-right-radius: ${($ = o == null ? void 0 : o.get) == null ? void 0 : $.call(o, "tokens.radius.calendarDayRadius")}px;
      clip-path: polygon(0 0, 100% 0, 100% calc(100% - 16px), calc(100% - 16px) 100%, 0 100%);
    `;
}}

  @media ${c.medium} {
    --extension-width: 32px;

    height: 40px;
    padding: 9px 3px 11px;
  }
`, S = l.span`
  ${(i) => u(i)}
  ${({ theme: i }) => {
  var r, o;
  return (o = (r = i == null ? void 0 : i.get) == null ? void 0 : r.call(i, "tokens.body.productive")) == null ? void 0 : o.toJS();
}}
  line-height: 20px;

  @media ${c.medium} {
    ${({ theme: i }) => {
  var r, o;
  return (o = (r = i == null ? void 0 : i.get) == null ? void 0 : r.call(i, "tokens.body.expressive")) == null ? void 0 : o.toJS();
}}
    line-height: 24px;
  }
`, v = l.span`
  ${(i) => u(i, !0)}
  ${({ theme: i }) => {
  var r, o;
  return (o = (r = i == null ? void 0 : i.get) == null ? void 0 : r.call(i, "tokens.helper.xs-productive")) == null ? void 0 : o.toJS();
}}
  line-height: 1;

  @media ${c.medium} {
    ${({ theme: i }) => {
  var r, o;
  return (o = (r = i == null ? void 0 : i.get) == null ? void 0 : r.call(i, "tokens.helper.productive")) == null ? void 0 : o.toJS();
}}
  }
`, D = l.span`
  ${(i) => u(i, !0)}
  ${({ theme: i }) => {
  var r, o;
  return (o = (r = i == null ? void 0 : i.get) == null ? void 0 : r.call(i, "tokens.helper.xs-productive")) == null ? void 0 : o.toJS();
}}

  text-decoration: line-through;

  @media ${c.medium} {
    ${({ theme: i }) => {
  var r, o;
  return (o = (r = i == null ? void 0 : i.get) == null ? void 0 : r.call(i, "tokens.helper.productive")) == null ? void 0 : o.toJS();
}}
  }
`, y = l.span`
  ${({ theme: i }) => {
  var r, o;
  return (o = (r = i == null ? void 0 : i.get) == null ? void 0 : r.call(i, "tokens.helper.xs-productive")) == null ? void 0 : o.toJS();
}}
  color: ${({ $colorTheme: i, theme: r }) => {
  var o;
  return (o = r == null ? void 0 : r.get) == null ? void 0 : o.call(r, `ui.calendar.${i}.arrDepText`);
}};
  line-height: 1;

  @media ${c.medium} {
    ${({ theme: i }) => {
  var r, o;
  return (o = (r = i == null ? void 0 : i.get) == null ? void 0 : r.call(i, "tokens.helper.productive")) == null ? void 0 : o.toJS();
}}
  }
`;
export {
  y as DashText,
  S as DayText,
  v as PriceText,
  D as StrikePriceText,
  f as TableDataCellContent
};
